import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { Button, Col, Row } from 'reactstrap';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../context/auth';

//Components
import CardRelatorio from '../components/CardRelatorio';
import MainCard from '../../../components/MainCard/MainCard';

//Helpers
import mascaras from '../../../helpers/mascaras';

function RelatorioTransportadoresContratosGeradores({ btnVoltar, filtros, dadosRelatorio }) {
  const { setupVariavel, session } = useAuth();

  const [dados, setDados] = useState([]);

  const [csvDado, setCsvDado] = useState([]);

  //Referencia do relatorio para impressão pdf
  const refRelatorio = useRef(null);

  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  //Cabeçalho do CSV
  const headersCSV = [
    { label: "Razão Social Transportador", key: "razaoSocialTransportador" },
    { label: "CNPJ Transportador", key: "cnpjTransportador" },
    { label: "Razão Social Gerador", key: "razaoSocialGerador" },
    { label: "CNPJ Gerador", key: "cnpjGerador" },
    { label: "Endereço", key: "endereco" },
    { label: "Status Contrato", key: "statusContrato" },
    { label: "Validade", key: "validade" },
    { label: "Modalidade", key: "modalidade" },
  ];


  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => refRelatorio.current,
    copyStyles: true,
    documentTitle: "Relatório Contratos com Geradores",
  });

  //Botão de exportação csv
  const BtnExportCsv = () => {
    return (
      <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
        <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
      </Button>
    )
  }

  useEffect(() => {
    if (dadosRelatorio?.length > 0) {
      setDados([
        ...dadosRelatorio.map(value => {
          value.cnpj = mascaras.cpfcnpjMask(value.cnpj);
          return value;
        })])

      setCsvDado([
        ...dadosRelatorio
          .flatMap(({ relatorioContratosPorTransportadores }) => relatorioContratosPorTransportadores)
          .map(value => {
            value.cnpjTransportador = mascaras.cpfcnpjMask(value.cnpjTransportador);
            value.cnpjGerador = mascaras.cpfcnpjMask(value.cnpjGerador);
            return value;
          })
      ]);
    }
  }, []);

  return (
    <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
      <CSVLink
        separator={";"}
        data={csvDado}
        headers={headersCSV}
        filename="Relatório Contratos com Geradores.csv"
        target="_blank"
        ref={exportRef}
      />
      <div className="mt-4 relatorio w-100" ref={refRelatorio}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>
        {setupVariavel?.logoTipo &&
          <div className="d-flex align-items-center justify-content-center">
            <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
          </div>
        }
        <div className="header">
          <h4 className='text-black'>Relatório Transportadores com Contratos por Geradores</h4>
          <Row>
            <div className='col-6'>
              {filtros.modalidadeId_selected && <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>}
            </div>
          </Row>
        </div>
        <div className="body">
          {dados.map((value, index) => (
            <div key={index} className='w-100'>
              <div className='row'>

                <h5 className='rounded-3 bg-secondary text-light p-2 d-flex align-itms-center justify-content-between'>
                  <span>{value.razaoSocial}</span> <span>{mascaras.cpfcnpjMask(value.cnpj)}</span>
                </h5>

                {value.relatorioContratosPorTransportadores.map((contrato, indexContrato) => (
                  <div key={indexContrato} className='row pb-2'  style={{ background: indexContrato % 2 == 0 ? "#ebeaea" : "#fff" }}>
                    <div className='col-lg-6'>
                      <span className='fw-bold'>CNPJ:</span> {mascaras.cpfcnpjMask(contrato.cnpjGerador)}
                    </div>
                    <div className='col-lg-6'>
                      <span className='fw-bold'>Razão Social:</span> {contrato.razaoSocialGerador}
                    </div>
                    <div className='col-lg-12'>
                      <span className='fw-bold'>Endereço:</span> {contrato.endereco}
                    </div>
                    <div className='col-lg-12'>
                      <span className='fw-bold'>Modalidade:</span> {contrato.modalidade}
                    </div>
                    <div className='col-lg-6'>
                      <span className='fw-bold'>Status:</span> {contrato.statusContrato}
                    </div>
                    <div className='col-lg-6'>
                      <span className='fw-bold'>Validade Contrato:</span> {contrato.validade}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainCard>
  );
}

export default RelatorioTransportadoresContratosGeradores;